import { render, staticRenderFns } from "./MembershipForm.vue?vue&type=template&id=064f74ac&"
import script from "./MembershipForm.vue?vue&type=script&lang=ts&"
export * from "./MembershipForm.vue?vue&type=script&lang=ts&"
import style0 from "./MembershipForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports